function showAlerts() {
  $('.alert-module').each(function () {
    const alertId = $(this).attr('id');
    let alreadyClosed = wasAlreadyClosed(alertId);

    if (!alreadyClosed) {
      $('#' + alertId).removeClass('d-none');
    }
  });

  $('.alert-module-close').on('click', function () {
    const alert = $(this).closest('.alert-module');
    const alertId = alert.attr('id');
    const alertUpdate = alert.data('update');
    localStorage.setItem(alertId, alertUpdate);
    $('#' + alertId).addClass('d-none');
  });
}

function wasAlreadyClosed(alert_id) {
  const alert = $('#' + alert_id);

  if (alert.length) {
    const alertUpdate = alert.data('update');
    const alertInfo = localStorage.getItem(alert_id);

    return (alertInfo == alertUpdate);
  }
}

export { showAlerts }


// WEBPACK FOOTER //
// ./scripts/modules/alert.js